module.exports = __webpack_public_path__ + "minus-q.png?7efd838a5b87ebf30ed05c2577b3c398";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minus-q.png
// module id = 217
// module chunks = 0